import styled, { css } from 'styled-components';
import { Loader as LoaderComponent } from 'src/components';

export const LoaderWrapper = styled.div(
  () => css`
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
);

export const Loader = styled(LoaderComponent)(
  ({ theme }) => css`
    width: ${theme.sz.s12};

    @media (min-width: ${theme.sz.xl}) {
      width: ${theme.sz.s40};
    }
  `,
);
